import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

/* import { Plugins } from '@capacitor/core';
const { App } = Plugins;

App.addListener('appUrlOpen', function (data) {
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  const slug = data.url.split('.app').pop();

  // We only push to the route if there is a slug present
  if (slug) {
    router.push({
      path: slug,
    });
  }
}); */

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/setup",
    name: "Setup",
    component: () => import("../views/Setup.vue"),
  },
  {
    path: "/menu-full",
    name: "MenuFull",
    component: () => import("../views/MenuFull.vue"),
    meta: { tabBar: true, tabIndex: 1 },
  },
  {
    path: "/message",
    name: "Message",
    component: () => import("../views/Message.vue"),
  },
];

// history mode not work in electron
const router = new VueRouter({
  //mode: 'abstract',
  //mode: "history",
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  console.log("router", to, from);
  
  store.state.routeFrom = from;

  if (from.name == to.name) next(false);
  else if (window.innerWidth < 600 || window.innerHeight < 600) {
    if (to.name == "Message") next();
    else
      next({
        name: "Message",
        params: {
          messageCode: "INCOMPATIBLE_DEVICE",
        },
      });
  } else if (to.name == "Setup") {
    if (to.params.authorized === true) next();
    else next({ name: "Home" });
  } else if (to.name == "Home") {
    if (to.params.authorized === true || !store.state.Pad.currentTable || from.name == "Setup") next();
    else next(false);
  } else if (to.name != "Home" && (!store.state.appInitialized || store.state.Store.store == null))
    next({ name: "Home" });
  else next();
});

export default router;
